// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__i+lAG","indicator":"styles_indicator__yT8DZ"};